import { jsx } from "react/jsx-runtime";
import React from "react";
var chevron_up_small_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.9993 8.4004-5.7857 5.785 1.4141 1.4143 4.3716-4.3711 4.3717 4.3711 1.4142-1.4143-5.7859-5.785z" })];
};
export {
  chevron_up_small_default as default
};
